import { serviceTypeForHomePage } from '@shared/service_types'
import { useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { useClientLocationServiceType } from 'service-api/src/hooks/use_client_location_service_type'
import { useRoutes } from 'app/use_routes'

export const RedirectPage = () => {
  const { accountName: locationName = '' } = useParams()
  const [searchParams] = useSearchParams()
  const serviceTypes = useClientLocationServiceType(locationName, {
    restrictions: true,
  })
  const { buildPath } = useRoutes()

  useEffect(() => {
    if (serviceTypes.isSuccess) {
      const stRedirect = serviceTypeForHomePage(serviceTypes.data.results)
      if (stRedirect) {
        const path = buildPath('searchServiceType', {
          accountName: locationName,
          serviceTypeName: stRedirect?.serviceType?.name || 'boarding',
        })
        window.location.href = path + (searchParams.toString() ? `?${searchParams.toString()}` : '')
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceTypes.isSuccess])

  return null
}
